import React from 'react';
import styled from 'styled-components';

const subscribeIframe =
  '<iframe src="https://upscri.be/b98e6a?as_embed" height="300" frameborder="0" style="width:100%;max-width:500px;margin:0 auto;"></iframe>';

export default () => <Centered dangerouslySetInnerHTML={{ __html: subscribeIframe }} />;

const Centered = styled.div`
  display: flex;
  justify-content: center;
  border-top: 1px solid #f2f2f2;
  border-bottom: 1px solid #f2f2f2;
`;
